exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n#external-events {\r\n  float: left;\r\n  width: 200px;\r\n}\r\n\r\n#external-events .fc-event {\r\n  margin: 10px 0;\r\n  cursor: pointer;\r\n}\r\n\r\n#external-events p {\r\n  margin: 1.5em 0;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n#external-events p input {\r\n  margin: 0;\r\n  vertical-align: middle;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/task-list/task-list.component.css
// module id = ../../../../../src/app/controllers/calendars/task-list/task-list.component.css
// module chunks = main